import type { ExportHeaderInfo } from './types';

/**
 * Build project data + report title rows for export (CSV/Excel/ODS).
 * First row: project name (title), then optional company/address/drawnBy/revision, then report title, then empty.
 */
export function buildExportHeaderRows(
  header: ExportHeaderInfo,
  columnCount: number,
): string[][] {
  const {
    projectName,
    companyName,
    companyAddress,
    drawnBy,
    revisionNumber,
    projectNumber,
    responsibleEngineer,
    description,
    reportTitle,
  } = header;
  const pad = (arr: string[]) =>
    arr.length >= columnCount
      ? arr
      : [...arr, ...Array(columnCount - arr.length).fill('')];
  const rows: string[][] = [];
  rows.push(pad([projectName]));
  if (companyName) rows.push(pad(['Company', companyName]));
  if (companyAddress) rows.push(pad(['Address', companyAddress]));
  if (drawnBy) rows.push(pad(['Drawn by', drawnBy]));
  if (revisionNumber) rows.push(pad(['Revision', revisionNumber]));
  if (projectNumber) rows.push(pad(['Project number', projectNumber]));
  if (responsibleEngineer)
    rows.push(pad(['Responsible engineer', responsibleEngineer]));
  if (description) rows.push(pad(['Description', description]));
  rows.push(pad([]));
  rows.push(pad([reportTitle]));
  rows.push(pad([]));
  return rows;
}
